export default __webpack_public_path__ + "static/devskillerShare-f7e8d41dbe7586ea0152dce2e1695e32.png";